import React from "react";
export default function () {
    return (
        <svg width="200" height="200" viewBox="0 0 200 200">
            <g>
                <path d="M34.2,90.5c-2.7-4.7-10.7-5.4-17.9-1.6S5.4,99.6,8.1,104.3s10.7,5.4,17.9,1.6S36.9,95.2,34.2,90.5Z" />
                <rect x="33.1" y="23" width="1.9" height="71.82" />
                <path d="M33.5,23h1.8s2.4,11.7,15.4,25c11.1,13.6,2.9,23.9,2.9,23.9l-.5-4.3.5-1.9s3.1-11.8-16.4-21.4c0,0,4.9,9.5,7.9,12.8s8.1,5.8,10.3,13.6A17.9,17.9,0,0,1,53,85.6c-.9,1-1.8.1-1.4-1.4s2.8-9,.6-12.3S42,61.6,37.3,59.5a6.1,6.1,0,0,0-1.9-.1H33.5Z" />
            </g>
        </svg>
    );
}
